import metadata from '../../bankrate-tracking/metadata'
import getPid, { getAttrPid } from './pid'
import { beamPageLoad } from '../../services/tagularEvent'
;(function() {
  beamPageLoad(
    'CookieIdentified',
    {
      key: 'pid_brmp',
      value: getPid()
    },
    'browser',
    'v1alpha'
  )

  beamPageLoad(
    'CookieIdentified',
    {
      key: 'pid_attr',
      value: getAttrPid()
    },
    'browser',
    'v1alpha'
  )

  const formatAttrList = attributeInput => {
    // Remove spaces before and after commas
    let attributeContent = attributeInput.split(/\s*(?:,|$)\s*/).join(',')
    // Replace spaces between words with underscores
    attributeContent = attributeContent
      .split(' ')
      .join('_')
      .toUpperCase()

    return attributeContent.split(',')
  }

  const createIsoDate = dateString => {
    if (!dateString) return

    let date = new Date(dateString)

    return date.toISOString()
  }

  const primaryCategory = metadata.getMetaData('Category') || ''
  const pageTitle = document.title
  const publishDate = document.querySelector('[name="Published"]')
  const publishDateISO = document.querySelector('[name="PublishedISO"]')
  const author = document.querySelector('[name="Author"]')
  const funnelStage = document.querySelector('[name="FunnelStage"]')
  const targetAudience = document.querySelector('[name="TargetPersona"]')
  const objective = document.querySelector('[name="Objective"]')
  const lastRefreshDate = document.querySelector('[name="Modified"]')
  const lastRefreshDateISO = document.querySelector('[name="ModifiedISO"]')
  let pageType = metadata.getMetaData('PageType') || ''
  let targetAudienceContent = targetAudience
    ? formatAttrList(targetAudience.getAttribute('content'))
    : null
  let objectiveContent = objective
    ? formatAttrList(objective.getAttribute('content'))
    : null
  let publishDateContent = createIsoDate(
    publishDateISO
      ? new Date(publishDateISO.getAttribute('content'))
      : publishDate
      ? new Date(publishDate.getAttribute('content'))
      : null
  )
  let lastRefreshDateContent = createIsoDate(
    lastRefreshDateISO
      ? new Date(lastRefreshDateISO.getAttribute('content'))
      : lastRefreshDate
      ? new Date(lastRefreshDate.getAttribute('content'))
      : null
  )

  if (window.pageTypeTagOverride) {
    pageType = window.pageTypeTagOverride
  }

  beamPageLoad(
    'ContentMetadataTracked',
    {
      contentName: pageTitle ? pageTitle : null,
      siteSection: '',
      category: primaryCategory ? primaryCategory : null,
      tags: [pageType],
      publishDate: publishDateContent,
      author: author ? author.getAttribute('content') : null,
      funnelStage: funnelStage
        ? funnelStage.getAttribute('content').toUpperCase()
        : null,
      targetAudience: targetAudienceContent,
      objective: objectiveContent,
      lastRefreshDate: lastRefreshDateContent
    },
    'usertracking',
    'v4'
  )
})()
